import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaychexContinueContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PaychexContinueContainer" */
                '@perpay-web/fintech/components/composite/PaychexOnboarding/PaychexContinueContainer'
            ),
    );
